<!-- Navbar -->

<template>
<div id="navbar">
  <nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item" href="/">
        <img src="../assets/logo_mobidata.png">
      </a>
      <a class="navbar-item" href="/">
        <img src="../assets/logo_atu.png">
      </a>

      <a
        role="button"
        class="navbar-burger burger"
        aria-label="menu"
        aria-expanded="false"
        data-target="navbarBasicExample"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div id="navbarBasicExample" class="navbar-menu">
      <div class="navbar-start">
        <router-link class="navbar-item is-light" to="/">{{ $t('menu')}}</router-link>
        <router-link class="navbar-item is-light" to="/users" v-if="isAdmin">{{ $t('users')}}</router-link>
      </div>

      <div class="navbar-menu navbar-end">
        <!-- Google login button -->
        <div class="buttons" v-if="!isUserLogged">
          <a>
            <button class="btn-google" v-google-signin-button="client_id">
              <div class="icon-google"></div>
              <span class="google-text">{{$t('googleConnect')}}</span>
            </button>
          </a>
        </div>
        <!-- User information if logged -->
        <div @mouseover="showDisconnect = true" @mouseleave="showDisconnect = false" :class="{notDisplayed: !isUserLogged}">
          <div class="user-informations" :key="userComponent">
            <div class="username" v-if="isUserLogged">{{$store.getters.getUser.decodedJwtToken.name}}</div>
            <div class="avatar"></div>
          </div>
          <div class="dropdown-container" v-if="showDisconnect && isUserLogged">
            <p @click="signOut()" class="dropdown-option">{{ $t("disconnect") }}</p>
          </div>
        </div>
      </div>
    </div>
  </nav>
</div>
</template>

<script>
import axios from 'axios'
import GoogleSignInButton from 'vue-google-signin-button-directive'
import jwtDecode from "jwt-decode"
import displayMessage from '../displayMessage.js'
import timeoutHandler from '../timeoutHandler.js'

export default {
  name: "NavBar",
  data() {
    return {
      client_id: process.env.VUE_APP_GOOGLE_TOKEN,
      showDisconnect: false,
      userComponent: 0, // used to re-render the user when he google connect, resolves a graphical bug
    };
  },
  mounted() {
    // if user is log, check if his credentials are still valids
    if (this.$store.getters.getUser.decodedJwtToken) {

      // jwt token expiration timestamp and current timestamp
      var exp = this.$store.getters.getUser.decodedJwtToken.exp * 1000
      var currentTimestamp = Date.now()

      // Log out the user if there is an expired jwt token on the store, else set a timeout with the lasting time
      if (exp - currentTimestamp < 0) {
        this.$store.commit('setUser', {'decoded': null, 'jwtToken': null, 'roles': null, 'runningTimeout': null})
        displayMessage.display(this, this.$t('timeoutMessage'), this.$t('close'), true)
      } else {
        var timeout = timeoutHandler.createTimeout(this, exp - currentTimestamp)
      }
    }

    // Set the user image if he is already logged
    this.setUserImage()
  },
  methods: {
    OnGoogleAuthSuccess (idToken) {
      const backendUrl = process.env.VUE_APP_BACKEND_URL || "http://localhost:3005"
      var decoded = jwtDecode(idToken)
      var userEmail = JSON.stringify(decoded.email)
      var vueApp = this
      axios.post(backendUrl + '/googleAuth', {}, {
        headers: {
          jwtToken: idToken,
          email: userEmail
        }
      })
      .then(response => {

        // create the timeout timestamp
        var timeoutTime = (decoded.exp - decoded.iat) * 1000
        var timeout = timeoutHandler.createTimeout(vueApp, timeoutTime)

        // save the jwt token and its decoded informations
        this.$store.commit('setUser', {'decoded': decoded, 'jwtToken': idToken, 'roles': response.data, 'runningTimeout': timeout})
        this.setUserImage()
        this.showDisconnect = false

      })
      .catch(err => {
        if (err && err.response && err.response.data) {
          if (err.response.data == "forbidden user") {
            // tells the user he is not allowed to use the app
            displayMessage.display(vueApp, this.$t('unautorizedUser'), this.$t('close'), false)
          }
          else if (err.response.data == "timeout") {
            displayMessage.display(vueApp, this.$t('timeoutMessage'), this.$t('close'), true)
          }
        }
        console.log(err)
      })
    },
    OnGoogleAuthFail (error) {
      console.log(error)
    },
    signOut () {
      // delete the user informations and jwtToken from the store
      this.$store.commit('setUser', {'decoded': null, 'jwtToken': null, 'roles': null, 'runningTimeout': null})
      console.log('User signed out.')
      // If user disconnected on the users page, redirect him to the main page
      if (this.$route.path == '/users') {
        this.$router.push('/')
      }
    },
    setUserImage () {
      this.forceRerender()
      // wait for the DOM to be refreshed before we add the user image
      this.$nextTick(function () {
        var decodedJwtToken = this.$store.getters.getUser.decodedJwtToken
        if (decodedJwtToken) {
          var avatarUrl = this.$store.getters.getUser.decodedJwtToken.picture
          var avatarElement = document.getElementsByClassName('avatar')[0]
          avatarElement.style.backgroundImage = "url('"+avatarUrl+"')"
          avatarElement.style.width = "2.5rem"
          avatarElement.style.heigth = "2.5rem"
        }
      })
    },
    forceRerender(callback) {
      this.userComponent += 1
    },
  },
  computed: {
    isUserLogged: function () {
      var userInformations = this.$store.state.user.decodedJwtToken
      if (userInformations) {
        return true
      }
      return false
    },
    isAdmin: function () {
      var userRoles = this.$store.getters.getUser.roles
      if (userRoles && Array.isArray(userRoles) && userRoles.includes('ADMIN')) {
        return true
      }
      return false
    },
  }
};
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/navbar.sass"
</style>


// WEBPACK FOOTER //
// src/components/Navbar.vue